export enum CartOrderTarget {
  NewDraft = 'newDraft',
  ExistingDraft = 'existingDraft',
}
